import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Data,
  CanLoad,
  Route,
  UrlSegment,
  CanActivateChild,
  CanDeactivate
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './shared/services/auth/auth.service';
import { DialogService } from './shared/services/dialog.service';
import { BackgroundService } from './shared/services/background.service';
import { FormControl, FormGroup, FormArray } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class GuardGuard implements CanActivate, CanActivateChild, CanLoad, CanDeactivate<any> {
  constructor(
    private auth: AuthService,
    private router: Router,
    private dialog: DialogService,
    private backgroundService: BackgroundService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.initiateGuard(next.data);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.initiateGuard(next.data);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this.initiateGuard(route.data);
  }

  async canDeactivate(component: Object) {
    const canDeactivate = Object.values(component).every(prop => {
      if (prop instanceof FormControl || prop instanceof FormGroup || prop instanceof FormArray)
        if (prop.dirty) return false;

      return true;
    });

    if (canDeactivate) return true;

    return await this.dialog
      .confirm('האם אתם בטוחים שברצונכם לצאת מעמוד זה?', 'השינויים שהוזנו לא יישמרו.', 'יציאה', 'להשאר')
      .catch(e => {
        console.error(e);
        return false;
      });
  }

  private async initiateGuard(data: Data): Promise<boolean> {
    const guard = await this.guard(data as Data & { guard: iGuard });
    return guard;
  }

  private async guard(data: Data & { guard: iGuard }): Promise<boolean> {
    if (!data.guard) return true;

    await this.auth.promise;

    if (data.guard.loggedin === true) if (!this.validate(!this.auth.user, data)) return false;

    if (data.guard.loggedin === false) if (!this.validate(!!this.auth.user, data)) return false;

    return true;
  }

  private validate(fail: boolean, data: Data): boolean {
    if (!fail) return true;

    if (data.guard.redirect) this.router.navigate(data.guard.redirect);
    if (data.guard.alert) this.dialog.alert('שגיאה', data.guard.alert);

    return false;
  }
}

export interface iGuard {
  loggedin?: boolean;
  alert?: string | false;
  redirect?: string[] | false;
}
